module.exports = __webpack_public_path__ + "static/media/LockUnlock.8aa3c203.svg";